export default class ExternalReview {

    constructor(data, iconScore, locale) {
        const t = document.querySelector('#external-review');
        this.instance = t.content.cloneNode(true);
        this.data = data;
        this.iconScore = iconScore;
        this.locale = locale;
        this.trustpilotReviewUrl = "https://www.trustpilot.com/reviews/";
        if (data.isTotalReviews) {
            this.setTotalReviews();
        } else {
            this.setReview();
        }
        return this.instance;
    }

    setReview() {
        const review = this.instance.querySelector('[name="review"]');
        this.instance.querySelector('[name="total-reviews"]').remove();

        this.setScore(review);
        this.setTrustpilotReviewUrl(review);
        review.querySelector('[name="date"]').textContent = this.data.date;
        review.querySelector('[name="opinion"]').textContent = this.data.opinion;
        review.querySelector('[name="title"]').textContent = this.data.title;
        review.querySelector('[name="fullName"]').textContent = this.data.fullName;
    }

    setTotalReviews() {
        const totalReviews = this.instance.querySelector('[name="total-reviews"]');
        this.instance.querySelector('[name="review"]').remove();

        this.setScore(totalReviews);
        totalReviews.querySelector('[name="logo"]').src = this.data.logo;
        totalReviews.querySelector('[name="textScore"]').innerHTML = this.data.textScore;
        if (this.data.logoLink) totalReviews.querySelector('[name="logo-link"]').href = this.data.logoLink;

    }

    setScore(parent) {
        const score = parseFloat(this.data.score);
        let classScore = '';
        let halfScore = score % 1 == 0 ? false : true;
        switch (true) {
            case score == 0:
                classScore = 'empty'
                break;
            case score < 2:
                classScore = 'terrible'
                break;

            case score < 3:
                classScore = 'bad'
                break;

            case score < 4:
                classScore = 'normal'
                break;

            case score < 5:
                classScore = 'good'
                break;

            case score == 5:
                classScore = 'excelent'
                break;
        }
        const scoreItemTemplate = parent.querySelector('[name="score"] [name="item-score"]');
        const scoreItems = [];
        for (let i = 0; i < 5; i++) {
            const scoreItem = scoreItemTemplate.cloneNode(true);
            if (i < score) {
                scoreItem.classList.add(classScore);
            } else {
                scoreItem.classList.add('empty');
            }
            if (halfScore && Math.floor(score) == i) {
                scoreItem.classList.add('half');
            }
            scoreItem.querySelector('i').classList.add(this.iconScore);
            scoreItems.push(scoreItem);
        }
        const scoreItemsParent = scoreItemTemplate.parentNode;
        scoreItemTemplate.remove();
        scoreItems.forEach(scoreItem => scoreItemsParent.appendChild(scoreItem))
    }

    setTrustpilotReviewUrl(review) {
        if (!this.data.trustpilotReviewId || !this.locale) {
            return;
        }
        if (this.locale !== 'en') {
            this.trustpilotReviewUrl = this.trustpilotReviewUrl.replace(
                'www',
                this.locale === 'ca' ? 'es' : this.locale
            );
        }
        review.href = this.trustpilotReviewUrl + this.data.trustpilotReviewId;
    }
}

